import React, { Component } from 'react'
import { breakpoint } from '../../styles'

/**
 * @deprecated Rather use MediaQueryProvider
 */
const handleMediaQuery =
  (config = {}) =>
  WrappedComponent => {
    const breakpointToTrack = config.breakpoints || []

    class MediaQueryHandler extends Component {
      // eslint-disable-next-line react/state-in-constructor
      state = {
        matchesPhone: false,
        matchesTablet: false,
        matchesDesktop: false,
        matchesBreakpoints: {},
      }

      componentDidMount() {
        this.phoneQueryList = window.matchMedia(`(min-width: ${breakpoint.phone}px)`)
        this.phoneQueryList.addListener(this.onPhoneChange)

        this.tabletQueryList = window.matchMedia(`(min-width: ${breakpoint.tablet}px)`)
        this.tabletQueryList.addListener(this.onTabletChange)

        this.desktopQueryList = window.matchMedia(`(min-width: ${breakpoint.desktop}px)`)
        this.desktopQueryList.addListener(this.onDesktopChange)
        this.onDesktopChange()

        const stateBreakpoints = {}

        // Track custom breakpoints for media changes
        this.breakpoints = {}
        breakpointToTrack.forEach(bp => {
          const media = `(min-width: ${bp}px)`
          const queryList = window.matchMedia(media)
          queryList.addListener(this.onMediaChange)

          this.breakpoints[media] = {
            value: bp,
            queryList,
          }

          stateBreakpoints[bp] = queryList.matches
        })

        // Store the results in the state
        this.setState({
          matchesPhone: this.phoneQueryList.matches,
          matchesTablet: this.tabletQueryList.matches,
          matchesDesktop: this.desktopQueryList.matches,
          matchesBreakpoints: stateBreakpoints,
        })
      }

      componentWillUnmount() {
        // Remove listeners for set breakpoints
        if (this.phoneQueryList) this.phoneQueryList.removeListener(this.onPhoneChange)
        if (this.tabletQueryList) this.tabletQueryList.removeListener(this.onTabletChange)
        if (this.desktopQueryList) this.desktopQueryList.removeListener(this.onDesktopChange)

        // Remove listeners for custom breakpoints
        if (this.breakpoints) {
          Object.values(this.breakpoints).map(({ queryList }) => queryList.removeListener(this.onMediaChange))
        }
      }

      onPhoneChange = () => this.setState({ matchesPhone: this.phoneQueryList.matches })

      onTabletChange = () => this.setState({ matchesTablet: this.tabletQueryList.matches })

      onDesktopChange = () => this.setState({ matchesDesktop: this.desktopQueryList.matches })

      onMediaChange = match => {
        // Update the result for the breakpoint in the state
        const trackedBreakpoint = this.breakpoints[match.media]
        this.setState({
          matchesBreakpoints: {
            // eslint-disable-next-line react/no-access-state-in-setstate
            ...this.state.matchesBreakpoints,
            [trackedBreakpoint.value]: match.matches,
          },
        })
      }

      render() {
        return (
          <WrappedComponent
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...this.props}
            isPhoneOrLarger={this.state.matchesPhone}
            isTabletOrLarger={this.state.matchesTablet}
            isDesktopOrLarger={this.state.matchesDesktop}
            isBreakpointOrLarger={this.state.matchesBreakpoints}
          />
        )
      }
    }

    MediaQueryHandler.displayName = `HandleMediaQuery(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`
    return MediaQueryHandler
  }

export default handleMediaQuery
